enum EnumNoPermissionErrorSource {
    FromURL = 0,    // user key in wrong URL
    FromButton = 1, // user press button lead to illage page
}

export default EnumNoPermissionErrorSource
